import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { AppBar, Box, IconButton, Toolbar, Tooltip } from '@material-ui/core';
import { experimentalStyled } from '@material-ui/core/styles';
import MenuIcon from '../../icons/Menu';
import AccountPopover from './AccountPopover';
import NotificationsPopover from './NotificationsPopover';
import { isBase64 } from '../../utils/base64Utils';
// import LanguagePopover from './LanguagePopover';
// import AuthGuard from '../AuthGuard';
// import * as userPermissions from '../../consts/userRoles';
import SchoolIcon from '@mui/icons-material/School';

const DashboardNavbarRoot = experimentalStyled(AppBar)(({ theme }) => ({
  ...(theme.palette.mode === 'light' && {
    backgroundColor: process.env.REACT_APP_TOPBAR_COLOR || theme.palette.primary.contrastText,
    boxShadow: process.env.REACT_APP_TOPBAR_COLOR ? '0px 4px 4px rgba(0, 0, 0, 0.25)' : 'none',
    color: process.env.REACT_APP_TOPBAR_COLOR || theme.palette.primary.contrastText
  }),
  ...(theme.palette.mode === 'dark' && {
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.divider}`,
    boxShadow: 'none'
  }),
  zIndex: theme.zIndex.drawer + 100
}));

const getLogo = () => {
  let logo = null;
  if (process && process.env && process.env.REACT_APP_CLIENT_LOGO) {
    const b64_logo = process.env.REACT_APP_CLIENT_LOGO;
    if (b64_logo.length > 0) {
      const b64_arr = b64_logo.split(',');
      if (b64_arr && b64_arr[1]) {
        logo = isBase64(b64_arr[1]) ? b64_logo : null;
      }
    }
  }
  return logo;
}

const DashboardNavbar = (props) => {
  const { onSidebarOpen, /*isSidebarOpen*/ } = props;
  const clientLogo = getLogo();

  return (
    <DashboardNavbarRoot>
      <Toolbar sx={{ height: "64px !important", borderBottom: '1px solid rgba(0, 0, 0, 0.12)' }}>
        <IconButton
          color="inherit"
          onClick={onSidebarOpen}
          sx={{
            display: {
              //lg: 'none'
            },
          }}
        >
          <MenuIcon
            sx={{
              color: 'primary.main'
            }}
            fontSize="small"
          />
        </IconButton>

        <Box
          sx={{
            height: "100%"
          }}
        >
          <RouterLink
            style={{
              height: "inherit",
              display: "flex"
            }}
            to="/"
          >
            {
              clientLogo ?
                <>
                  <img
                    style={{
                      display: "flex",
                      padding: "10px",
                      height: "50px",
                      marginTop: "8px"
                    }}
                    alt="Components"
                    src={`${clientLogo}`}
                  />
                  {/* {!process.env.REACT_APP_HROPS_LOGO && <div style={{ width: "1px", height: "inherit", background: "lightgray" }} />} */}
                </>
                :
                null
            }
            {process.env.REACT_APP_HROPS_LOGO === "true" &&
              <img
                style={{
                  minHeight: "inherit",
                  display: "flex",
                  padding: "10px"
                }}
                alt="Components"
                src="/static/logo.svg"
              />}
          </RouterLink>
        </Box>
        <Box
          sx={{
            flexGrow: 1,
            ml: 2
          }}
        />
        {process.env.REACT_APP_KNOWLEDGE_HUB_INTEGRATED === "true" &&
          <Box sx={{ ml: 1 }}>
            <Tooltip title="Knowledge Hub">
              <IconButton
                component="a"
                href="https://knowledgehub.bi4all.pt/"
                target="_blank"
              >
                <SchoolIcon />
              </IconButton>
            </Tooltip>
          </Box>}
        {/* {process.env.REACT_APP_AVAILABLE_LANGUAGES.split(';').length > 1 &&
          <Box sx={{ ml: 1 }}>
            <AuthGuard roles={userPermissions.PORTAL_LANGUAGE_CHANGE} componentPermission>
              <LanguagePopover />
            </AuthGuard>
          </Box>} */}
        {/* <Box sx={{ ml: 1 }}>
          <ContentSearch />
        </Box>
        <Box sx={{ ml: 1 }}>
          <ContactsPopover />
        </Box> */}
        <Box sx={{ ml: 2 }}>
          <NotificationsPopover />
        </Box>
        <Box sx={{ ml: 1 }}>
          <AccountPopover />
        </Box>
      </Toolbar>
    </DashboardNavbarRoot>
  );
};

DashboardNavbar.propTypes = {
  onSidebarOpen: PropTypes.func,
  //isSidebarOpen: PropTypes.bool,
};

export default DashboardNavbar;
